import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../context/user-context";

import useScrollTrigger from "../hooks/scroll-trigger";
import { Container, Fade, Grid } from "@mui/material";
import ThemeCard from "../components/card/theme-card";
import "../custom.d.ts";
import "./style.scss";
import Banner from "../components/banner/banner";
import ContactForm from "../components/form/contact-form";
import { BSGAPI } from "../auth/bsg-api";
import { ContextService } from "../context/context-service";
import { DWebContent } from "../model";
import YouTubeCard from "../components/card/youtube-card";
import BSGModal from "../components/modal/bsg-modal";
import IconCard from "../components/card/icon-card";
import BubbleChartOutlinedIcon from "@mui/icons-material/BubbleChartOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import EmojiSymbolsOutlinedIcon from "@mui/icons-material/EmojiSymbolsOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";

import TouchAppIcon from "@mui/icons-material/TouchApp";
import BusinessIcon from "@mui/icons-material/Business";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import PollIcon from "@mui/icons-material/Poll";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EvStationIcon from "@mui/icons-material/EvStation";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ApiIcon from "@mui/icons-material/Api";
import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import SpeedIcon from "@mui/icons-material/Speed";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import { useHistory } from "react-router-dom";
import Loading from "../components/loading/loading";
import GroupsIcon from "@mui/icons-material/Groups";
import ImageCard from "../components/card/image-card";

const Solution = (props: any) => {
  //const { children, window } = props;
  const { t, i18n } = useTranslation("content");

  const context = useContext(UserContext);

  const history = useHistory();
  const [webContent, setWebContent] = useState({} as DWebContent);
  const [loading, setLoading] = useState(true);

  const myRefWe = useRef<HTMLDivElement>(null);

  const getTrigger = useScrollTrigger();

  const [triggerWe, setTriggerWe] = useState(
    getTrigger(myRefWe.current).trigger
  );

  const [openRetail, setOpenRetail] = React.useState(false);
  const [openLogistics, setOpenLogistics] = React.useState(false);
  const [openHealthcare, setOpenHealthcare] = React.useState(false);

  useEffect(() => {
    window.onscroll = () => {
      setTriggerWe(getTrigger(myRefWe.current).trigger);
    };

    BSGAPI.getWebContent("solution").then((json) => {
      let webContent = json as DWebContent;
      setWebContent(webContent);
      document.title = `${ContextService.SITE_NAME}:${webContent.title}`;
      setLoading(false);
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Loading show={loading} />
      {webContent.theme && (
        <ThemeCard
          backgroundImg={webContent.theme.image}
          opacity={0.9}
          title={webContent.theme.title as string}
          description={webContent.theme.description as string}
          minHeight={webContent.theme.height}
          caption={webContent.theme.caption}
          route={webContent.theme.route}
          routeText={webContent.theme.routeText}
        >
          <Container maxWidth="md">
            <div className="section">
              <h1 className="center secondary-light">
                {webContent.theme.h1?.title}
              </h1>
              {webContent.theme.h1?.children?.map((child) => {
                return (
                  <h2 className="center secondary-light">{child.content}</h2>
                );
              })}
            </div>
          </Container>

          <Container maxWidth="lg">
            <Grid
              container
              spacing={6}
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              alignContent="center"
            >
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                justifyContent="center"
              >
                <IconCard
                  icon={
                    <ShoppingCartIcon
                      color="secondary"
                      style={{ fontSize: 64 }}
                    />
                  }
                  title="Retail"
                  description="We help business solve problems"
                  onClick={() => {
                    setOpenRetail(true);
                  }}
                  onClickText="Read more ..."
                />

                <BSGModal
                  title="Retail - Shopping Experience"
                  open={openRetail}
                  onClose={() => {
                    setOpenRetail(false);
                  }}
                >
                  <Container maxWidth="lg">
                    <Grid
                      container
                      spacing={10}
                      direction="row"
                      justifyContent="center"
                      alignItems="stretch"
                    >
                      <Grid container item xs={12} justifyContent="left">
                        <h2 className="center secondary-light">
                          Continue improving shopping experience ...
                          <img
                            src="https://my-bsg-asset.s3.amazonaws.com/image/shopping_cart.jpg"
                            width="100%"
                          ></img>
                        </h2>

                        <h2>Features: </h2>
                        <li>
                          Real time map allows event organizer to learn who’s
                          visiting where
                        </li>
                        <li>
                          Vendors can know who are the visitors at booth and
                          provide targeted customized services{" "}
                        </li>
                        <li>Comprehensive analysis reports Target</li>
                        <h2>Clients: </h2>
                        <li>
                          Exhibitions and trade shows Product promotion events
                          Seminars
                        </li>
                        <h2>Why UBQ EMS</h2>
                        <li>
                          Better understand your visitor s interest and behavior
                          and provide customized services
                        </li>
                        <li>
                          Comprehensive and accurate report for post event
                          follow up
                        </li>
                      </Grid>
                    </Grid>
                  </Container>
                </BSGModal>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                justifyContent="center"
              >
                <IconCard
                  icon={
                    <GroupsIcon color="secondary" style={{ fontSize: 64 }} />
                  }
                  title="Event Management"
                  description="We build innovative products & solutions"
                  onClick={() => {
                    setOpenLogistics(true);
                  }}
                  onClickText="Read more ..."
                />

                <BSGModal
                  title="Event Management"
                  open={openLogistics}
                  onClose={() => {
                    setOpenLogistics(false);
                  }}
                >
                  <Container maxWidth="lg">
                    <Grid
                      container
                      spacing={10}
                      direction="row"
                      justifyContent="center"
                      alignItems="stretch"
                    >
                      <Grid container item xs={12} justifyContent="left">
                        <h2 className="center secondary-light">
                          Connect people in professional events
                          <img
                            src="https://my-bsg-asset.s3.amazonaws.com/image/event.jpg"
                            width="100%"
                          ></img>
                        </h2>

                        <h2>Features: </h2>
                        <li>
                          Real time map allows event organizer to learn who’s
                          visiting where
                        </li>
                        <li>
                          Vendors can know who are the visitors at booth and
                          provide targeted customized services{" "}
                        </li>
                        <li>Comprehensive analysis reports Target</li>
                        <h2>Clients: </h2>
                        <li>
                          Exhibitions and trade shows Product promotion events
                          Seminars
                        </li>
                        <h2>Why UBQ EMS</h2>
                        <li>
                          Better understand your visitor s interest and behavior
                          and provide customized services
                        </li>
                        <li>
                          Comprehensive and accurate report for post event
                          follow up
                        </li>
                      </Grid>
                    </Grid>
                  </Container>
                </BSGModal>
              </Grid>

              <Grid
                container
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                justifyContent="center"
              >
                <IconCard
                  icon={
                    <HealthAndSafetyIcon
                      color="secondary"
                      style={{ fontSize: 64 }}
                    />
                  }
                  title="Healthcare"
                  description="We train professionals with real project experience"
                  onClick={() => {
                    setOpenHealthcare(true);
                  }}
                  onClickText="Read more ..."
                />

                <BSGModal
                  title="Nursing Home"
                  open={openHealthcare}
                  onClose={() => {
                    setOpenHealthcare(false);
                  }}
                >
                  <Container maxWidth="lg">
                    <Grid
                      container
                      spacing={10}
                      direction="row"
                      justifyContent="center"
                      alignItems="stretch"
                    >
                      <Grid container item xs={12} justifyContent="left">
                        <h2 className="center secondary-light">
                          Watch with love
                          <img
                            src="https://my-bsg-asset.s3.amazonaws.com/image/nursing_home.jpg"
                            width="100%"
                          ></img>
                        </h2>

                        <h2>Features: </h2>
                        <li>
                          Real time map allows event organizer to learn who’s
                          visiting where
                        </li>
                        <li>
                          Vendors can know who are the visitors at booth and
                          provide targeted customized services{" "}
                        </li>
                        <li>Comprehensive analysis reports Target</li>
                        <h2>Clients: </h2>
                        <li>
                          Exhibitions and trade shows Product promotion events
                          Seminars
                        </li>
                        <h2>Why UBQ EMS</h2>
                        <li>
                          Better understand your visitor s interest and behavior
                          and provide customized services
                        </li>
                        <li>
                          Comprehensive and accurate report for post event
                          follow up
                        </li>
                      </Grid>
                    </Grid>
                  </Container>
                </BSGModal>
              </Grid>
            </Grid>
          </Container>

          <Container maxWidth="md">
            <div className="section">
              <h2 className="center secondary-light">
                {webContent.theme.h2?.title}
              </h2>
              {webContent.theme.h2?.children?.map((child) => {
                return (
                  <h3 className="center secondary-light">{child.content}</h3>
                );
              })}
            </div>
          </Container>
        </ThemeCard>
      )}

      <Fade in={triggerWe} timeout={4000}>
        <div ref={myRefWe}>
          <Banner>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignContent="flex-start"
            >
              <Grid
                container
                item
                xs={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <h1>{webContent.h1?.title}</h1>
              </Grid>
              {webContent.h1?.children?.map((child) => {
                return (
                  <Grid
                    container
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <h2>{child.content}</h2>
                  </Grid>
                );
              })}
            </Grid>
          </Banner>

          <div className="section-white">
            <Container maxWidth="md">
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignContent="flex-start"
              >
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >
                  <h2>more info goes here ...</h2>
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
      </Fade>

      <div className="center">
        <ContactForm />
      </div>
    </div>
  );
};

export default Solution;
